import { Box, Button, Flex } from "@chakra-ui/react";
import React from "react";
import { useForm } from "react-hook-form";
import { useReportError } from "../../../helpers/useReportError";
import {
  PasswordRequirements,
  validatePasswordInput,
} from "../../atoms/PasswordRequirements";
import { InputField } from "../../forms/InputField";

type AccountInviteNewUserFormValues = {
  newPassword: string;
};

export function AccountInviteNewUserForm({
  onSetPassword,
}: {
  onSetPassword: (
    props: AccountInviteNewUserFormValues,
  ) => Promise<void> | void;
}) {
  const form = useForm<AccountInviteNewUserFormValues>({
    mode: "onTouched",
    defaultValues: {
      newPassword: "",
    },
  });

  const {
    formState: { isValid, isSubmitting },
  } = form;

  const reportError = useReportError();

  const onSubmit = async (data: AccountInviteNewUserFormValues) => {
    const { newPassword } = data;

    try {
      await onSetPassword({ newPassword });
    } catch (error) {
      reportError(error, {
        title: "Verify account failed",
      });
    }
  };

  return (
    <Flex direction="column" w="full">
      <Box as="form" onSubmit={form.handleSubmit(onSubmit)} noValidate>
        <InputField
          form={form}
          name="newPassword"
          label="Password"
          type="password"
          autoComplete="new-password"
          isRequired
          autoFocus
          helperText={<PasswordRequirements />}
          rules={{
            validate: validatePasswordInput,
          }}
          backgroundColor="white"
        />

        <Button
          mt={4}
          variant="solid"
          colorScheme="primary"
          isDisabled={!isValid || isSubmitting}
          isLoading={isSubmitting}
          type="submit"
          width="full"
        >
          Set password
        </Button>
      </Box>
    </Flex>
  );
}
